import {Validator} from './Validator';


const requiredDate: Validator = (input: string) => {
  return (input ? null : 'Is required');
};

export {requiredDate};
